import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { DxDataGridComponent } from 'devextreme-angular';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-grid-edit-in-detail',
  templateUrl: './grid-edit-in-detail.component.html',
  styleUrls: ['./grid-edit-in-detail.component.css']
})
export class GridEditInDetailComponent implements OnInit {
  columns: any[];
  dataSource: any[];
  newRecord: any;
  tabDataSource = [
    { id: {}, title: 'List' }
  ];
  tabSelectedIndex = 0;
  allowDelete = true;

  @Output() refresh = new EventEmitter<void>();
  @Output() resetNewDetail = new EventEmitter<any>();
  @Output() selectedDetail = new EventEmitter<any>();
  @Output() showDetail = new EventEmitter<boolean>();
  @Output() saveDetail = new EventEmitter<any>();
  @Output() deleteDetail = new EventEmitter<any>();
  @Output() closeDetail = new EventEmitter<any>();
  
  constructor(private languageService: LanguageService) { }

  ngOnInit() {
  }

  @Input()
  set gridColumns(cols: any[]) {
    this.columns = cols;
  }

  @Input()
  set gridRecords(recs: any[]) {
    this.dataSource = recs;
  }

  @Input()
  set gridRecordNew(data: any) {
    this.newRecord = data;
  }

  @Input()
  set tabTitle(data: any) {
    if (data !== undefined) {
      this.tabDataSource[this.tabSelectedIndex].id = data;

      if (data.TabTitle !== undefined) {
        this.tabDataSource[this.tabSelectedIndex].title = data.TabTitle;
      }
      else if (data.Code !== undefined) {
        this.tabDataSource[this.tabSelectedIndex].title = data.Code;
      } else {
        this.tabDataSource[this.tabSelectedIndex].title = data.Name;
      }
    }
  }

  @Input()
  set gridAllowDelete(data: boolean) {
    this.allowDelete = data;
  }

  onRefresh() {
    this.refresh.emit();
  }

  onAdd() {
    this.resetNewDetail.emit();
    for (let i = 0; i < this.tabDataSource.length; i++) {
      let tab = this.tabDataSource[i];
      //if (this.newRecord === tab.id) {
      if (tab.title === this.languageService.LNG('Label.Add.New')) {
        this.tabSelectedIndex = i;
        this.showDetail.emit(true);
        this.selectedDetail.emit(this.tabDataSource[this.tabSelectedIndex].id);
        return;
      }
    }
    this.dataSource.push(this.newRecord);
    this.tabDataSource.push({ id: this.dataSource[this.dataSource.length - 1], title: this.languageService.LNG('Label.Add.New') });
    this.tabSelectedIndex = this.tabDataSource.length - 1;
    this.showDetail.emit(true);
    this.selectedDetail.emit(this.tabDataSource[this.tabSelectedIndex].id);    
  }

  onSaveDetail() {
    this.saveDetail.emit(this.tabDataSource[this.tabSelectedIndex].id);
  }

  onDeleteDetail() {
    this.deleteDetail.emit(this.tabDataSource[this.tabSelectedIndex].id);
    this.onCloseTab();
  }

  onCloseTab() {
    this.closeDetail.emit();
    this.tabDataSource.splice(this.tabSelectedIndex, 1);

    let tabIdx = this.tabDataSource.length - 1;
    if (tabIdx > 0) {
      this.tabSelectedIndex = this.tabDataSource.length - 1;
      this.showDetail.emit(true);
      this.selectedDetail.emit(this.tabDataSource[this.tabSelectedIndex].id);
    } else {
      this.tabSelectedIndex = 0;
      this.showDetail.emit(false);
    }
  }

  onTitleClick(e) {
    this.tabSelectedIndex = e.itemIndex;
    this.showDetail.emit(this.tabSelectedIndex !== 0);
    this.selectedDetail.emit(this.tabDataSource[e.itemIndex].id);
  }

  onTabTemplateClick(data: any) {
    for (let i = 0; i < this.tabDataSource.length; i++) {
      let tab = this.tabDataSource[i];
      if (data === tab.id) {
        return;
      }
    }
    if (data.TabTitle !== undefined) {
      this.tabDataSource.push({ id: data, title: data.TabTitle });
    }
    else if (data.Code !== undefined) {
      this.tabDataSource.push({ id: data, title: data.Code });
    } else {
      this.tabDataSource.push({ id: data, title: data.Name });
    }
  }

  onCellClick(e) {
    if (e.column.dataField !== undefined && !e.row.isEditing) {
      this.selectedDetail.emit(e.key);
      for (let i = 0; i < this.tabDataSource.length; i++) {
        let tab = this.tabDataSource[i];
        if (e.key === tab.id) {
          this.tabSelectedIndex = i;
          this.showDetail.emit(true);
          return;
        }
      }
      if (e.key.TabTitle !== undefined) {
        this.tabDataSource.push({ id: e.key, title: e.key.TabTitle });
      }
      else if (e.key.Code !== undefined) {
        this.tabDataSource.push({ id: e.key, title: e.key.Code });
      } else {
        this.tabDataSource.push({ id: e.key, title: e.key.Name });
      }
      this.tabSelectedIndex = this.tabDataSource.length - 1;
      this.showDetail.emit(true);
    }
  }

  onInitNewRow(e) {
  }
    
}
